import { actionTypes } from './constants';

const state = {
  data: {},
  loading: false,
  message: '',
  success: false,
  meta: {},
};

export const initialState = {
  detail: state,
  block: state,
  unblock: state,
  resend: state,
  plain: state,
  masked: state,
  search: { ...state, data: null },
};

export default function reducer(state = initialState, action) {
  const {
    type,
    data,
    loading,
    message = '',
    success = true,
    meta,
    // initial = true,
    key,
    error,
    code
  } = action;

  switch (type) {
    case actionTypes.FAILED:
      return {
        ...state,
        [key]: {
          ...state[key],
          data: data || initialState[key].data,
          error: error,
          loading: false,
          message,
          success: false,
          code,
        },
      };
    case actionTypes.LOADING:
      return {
        ...state,
        [key]: {
          ...state[key],
          success: false,
          loading,
          message: '',
        },
      };
    case actionTypes.SUCCESS:
      return {
        ...state,
        [key]: {
          ...state[key],
          data: data,
          meta,
          loading: false,
          error: {},
          message,
          success,
          code,
        },
      };
    case actionTypes.MESSAGE:
      return {
        ...state,
        [key]: {
          ...state[key],
          success: false,
          loading: false,
          message,
        },
      };
    case actionTypes.RESET:
      return{
        ...state,
        [key]: {
          ...state[key],
          success: false,
          data: null,
          code: 1
        }
      };
    default:
      return state;
  }
}
